import React from "react";
import Skeleton, { SkeletonTheme } from "react-loading-skeleton";
import "react-loading-skeleton/dist/skeleton.css";
import Button from "../../../../components/Buttons/button";
import { useFormattedAmount } from "../../../../hooks/useFormattedAmount";
import cn from "classnames";
import { useDispatch, useSelector } from "react-redux";

function PillCards({
  setPopup,
  setState,
  userId,
  userDetails,
  totalTeamCost,
  directTeamCost,
  averageEmployeeCost,
  totalSubmissions,
  totalFeedbacks,
  totalRequests,
  setDashboard,
}) {
  const formatFunction = useFormattedAmount();
  return (
    <SkeletonTheme baseColor="#3B4255" highlightColor="#0000001a">
      <div className="gap-[12px] md:gap-[20px] lg:gap-[32px]">
        <div className="flex flex-wrap gap-[12px] md:gap-[20px] lg:gap-[32px]">
          {userId == userDetails?.user?.id && (
            <div className="flex gap-[12px] w-full max-w-[100%] h-[100px] sm:max-w-[calc(33%-22px)] p-[12px] md:p-[24px] rounded-[12px] md:rounded-[24px] lg:rounded-[32px] bg-[#363D50]">
              <div className="flex justify-center flex-col gap-[6px] w-[203px] h-[51px]">
                {directTeamCost !== undefined && (
                  <span className="text-primary !text-[18px]">
                    {formatFunction(directTeamCost)}
                  </span>
                )}
                {directTeamCost === undefined && (
                  <Skeleton className="!w-[132px]" />
                )}
                <span className="text-secondary !leading-[21px]">
                  {" "}
                  Direct team's cost
                </span>
              </div>
            </div>
          )}

          <div
            className={`flex gap-[12px] w-full max-w-[100%] h-[100px] p-[12px] md:p-[24px] rounded-[12px] md:rounded-[24px] lg:rounded-[32px] bg-[#363D50] ${
              userId == userDetails?.user?.id
                ? "sm:max-w-[calc(33%-22px)]"
                : "sm:max-w-[calc(50%-16px)]"
            }`}
          >
            <div className="flex justify-center flex-col gap-[6px] w-[203px] h-[51px]">
              {totalTeamCost !== undefined && (
                <span className="text-primary !text-[18px]">
                  {formatFunction(totalTeamCost)}
                </span>
              )}
              {totalTeamCost === undefined && (
                <Skeleton className="!w-[132px]" />
              )}
              <span className="text-secondary !leading-[21px]">
                {" "}
                Total team cost
              </span>
            </div>
          </div>

          <div
            className={`flex justify-start flex-col w-full max-w-[100%] h-[100px] gap-[6px] p-[12px] md:p-[24px] rounded-[12px] md:rounded-[24px] lg:rounded-[32px] bg-[#363D50] ${
              userId == userDetails?.user?.id
                ? "sm:max-w-[calc(33%-22px)]"
                : "sm:max-w-[calc(50%-16px)]"
            }`}
          >
            {averageEmployeeCost !== undefined && (
              <span className="text-primary !text-[18px]">
                {formatFunction(averageEmployeeCost)}
              </span>
            )}
            {averageEmployeeCost === undefined && (
              <Skeleton className="!w-[132px]" />
            )}
            <span className="text-secondary !leading-[21px]">
              {" "}
              Average employee cost
            </span>
          </div>
        </div>
        <div className="flex flex-wrap pt-[12px] md:pt-[24px] lg:pt-[42px] gap-[12px] md:gap-[20px] lg:gap-[32px]">
          <div className="flex justify-between items-center w-full max-w-[100%] h-[100px] sm:max-w-[calc(33%-22px)] p-[12px] lg:p-[24px] gap-[16px] bg-[#363D50] rounded-[12px] md:rounded-[20px] lg:rounded-[32px]">
            <div className="flex flex-col gap-[6px] w-[203px] h-[51px]">
              {totalRequests && (
                <span className="text-primary !text-[18px]">
                  {totalRequests.length}
                </span>
              )}
              {!totalRequests && <Skeleton className="!w-[132px]" />}
              <span className="text-secondary !leading-[21px]">Requests</span>
            </div>
            <Button
              className={cn({
                invisible: !totalRequests?.length,
              })}
              onClick={() => {
                setPopup(true);
                setState(15);
                setDashboard("personalDashboard");
              }}
              secondary
              hoverColor
            >
              View
            </Button>
          </div>

          <div className="flex justify-between items-center w-full max-w-[100%] h-[100px] sm:max-w-[calc(33%-22px)] p-[12px] lg:p-[24px] gap-[16px] bg-[#363D50] rounded-[12px] md:rounded-[20px] lg:rounded-[32px]">
            <div className="flex flex-col gap-[6px] w-[203px] h-[51px]">
              {totalFeedbacks && (
                <span className="text-primary !text-[18px]">
                  {totalFeedbacks.length}
                </span>
              )}
              {!totalFeedbacks && <Skeleton className="!w-[132px]" />}
              <span className="text-secondary !leading-[21px]">Feedback</span>
            </div>
            <Button
              className={cn({
                invisible: !totalFeedbacks?.length,
              })}
              onClick={() => {
                setPopup(true);
                setState(16);
                setDashboard("personalDashboard");
              }}
              secondary
              hoverColor
            >
              View
            </Button>
          </div>

          <div className="flex justify-between items-center w-full max-w-[100%] h-[100px] sm:max-w-[calc(33%-22px)] p-[12px] lg:p-[24px] gap-[16px] bg-[#363D50] rounded-[12px] md:rounded-[20px] lg:rounded-[32px]">
            <div className="flex flex-col gap-[6px] w-[203px] h-[51px]">
              {totalSubmissions && (
                <span className="text-primary !text-[18px]">
                  {totalFeedbacks.length}
                </span>
              )}
              {!totalSubmissions && <Skeleton className="!w-[132px]" />}
              <span className="text-secondary !leading-[21px]">
                Submissions
              </span>
            </div>
            <Button
              className={cn({
                invisible: !totalSubmissions?.length,
              })}
              onClick={() => {
                setPopup(true);
                setState(17);
                setDashboard("personalDashboard");
              }}
              secondary
              hoverColor
            >
              View
            </Button>
          </div>
        </div>
      </div>
    </SkeletonTheme>
  );
}

export default PillCards;
